module.exports = __webpack_public_path__ + "./docs/img/big-icon-howto.ab32a61e846952c5cd436eeaef012bd1.svg";